import React, { Component } from "react";
import { connect } from "react-redux";
import { unselectFlight } from "../actions";
import { stopsFormatter, secondsToHHMM, dateToHHMM, cabinTranslations } from "../shared/utils";
import moment from "moment";

class FlightStretch extends Component {
	showDetails() {
		if (this.props.canUnselectFlight)
			return (
				<div className="flight-stretch-details">
					<a
						onClick={e => {
							e.preventDefault();
							this.props.unselectflight(this.props.flightdata);
						}}
						title="Escolher outro voo"
						className="btn btn-default btn-xs"
					>
						<i className="icon-close" />
						Escolher outro voo
					</a>
				</div>
			);

		if (this.props.showFlightDetails)
			return (
				<div className="flight-stretch-details">
					<a
						href=""
						title="Ver detalhes do voo"
						onClick={event => {
							this.props.onGetDetails(event);
						}}
						className="btn btn-default btn-xs"
					>
						{this.showIcon(this.props.shown)}
						Detalhes do voo
					</a>
				</div>
			);

		return <div className="col-xs-3 col-md-3 hidden-xs hidden-sm no-details" />;
	}

	showStops() {
		if (this.props.flightdata.stops !== undefined && this.props.showStops)
			return (
				<span className="flight-stops" aria-label="Paradas do voo">
					{stopsFormatter(this.props.flightdata.stops)}
				</span>
			);
	}

	showIcon(shown) {
		if (shown) return <i className="icon-reduction" />;

		return <i className="icon-addition" />;
	}

	checkTripsForAirportChange(trips) {
		if (trips)
			return (
				<span className="flight-airportchange">
					<i className="icon-change" />
				</span>
			);
	}

	returnCabin() {
		return cabinTranslations[this.props.tripdata.cabin];
	}

	render() {
		return (
			<div className="flight-row">
				<div className="row row-eq-heights">
					<div className="col-xs-4 col-md-4 no-padding">
						<span className="airline-name">
							{this.props.flightdata.airline || this.props.flightdata.carrier}
						</span>
						<span className="flight-number">{this.props.tripdata.flightNumber}</span>
					</div>
					<div className="col-xs-4 col-md-4">
						<div className="flight-timming">
							<span className="flight-time">{dateToHHMM(this.props.tripdata.departureDate)}</span>
							<span className="flight-destination">{this.props.tripdata.from}</span>
						</div>
						<span className="flight-data">
							{moment.utc(this.props.tripdata.departureDate).format("DD/MM/YY")}
						</span>
					</div>
					<div className="col-xs-4 col-md-4 no-padding">
						<div className="duration">
							<span
								className={
									this.props.flightdata.stops > 0 ? "flight-duration" : "flight-duration no-border"
								}
							>
								{secondsToHHMM(this.props.tripdata.duration * 60)}
							</span>
							{this.showStops()}
							{this.checkTripsForAirportChange(this.props.airportchange)}
						</div>
					</div>
					<div className="col-xs-4 col-md-4">
						<div className="flight-timming">
							<span className="flight-destination">{this.props.tripdata.to}</span>
							<span className="flight-time">{dateToHHMM(this.props.tripdata.arrivalDate)}</span>
						</div>
						<span className="flight-data">
							{moment.utc(this.props.tripdata.arrivalDate).format("DD/MM/YY")}
						</span>
					</div>
				</div>
			</div>
		);
	}
}

const mapDispatchToProps = dispatch => ({
	unselectflight: flightdata => {
		dispatch(unselectFlight(flightdata));
	}
});

export default connect(() => ({}), mapDispatchToProps)(FlightStretch);
